import React from 'react'

const MobileFilterBrands = () => {
	return (
		<div>
			<div className='mb-3'>
				<h5 className='text-normal text-black'>Brands</h5>
			</div>
			<div className='input-group input-group-outline mb-3'>
				<input type='text' className='form-control w-100' placeholder='Search for Brands' />
			</div>
			<div className='mb-3'>
				<h5 className='text-normal text-black'>Popular</h5>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						U.S. Polo Assn. <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Puma <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						FRISKERS <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						MAX <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Peter England <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Wrangler <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Van Hussen <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div className='mb-3'>
				<h5 className='text-normal text-black'>A</h5>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Apna Rajasthan <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						AARBEE <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Aarsha <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						ABLING <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						ABROS <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Access Her <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Ace Mode <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div className='mb-3'>
				<h5 className='text-normal text-black'>B</h5>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Bad Lab <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						BAGSTRAP <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Bags.R.Us <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						BAGGIT <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Balista <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Bani Women <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Baomi <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
		</div>
	)
}

export default MobileFilterBrands
